// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import {VueGMDSS} from '@/gmdss'
import router from './page'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import md5 from 'js-md5'
import Router from 'vue-router'
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import VueTouch from 'vue-touch'

Vue.use(VueTouch, {name: 'v-touch'})
VueTouch.config.swipe = {
  threshold: 10 // 手指左右滑动距离
}
Vue.use(VideoPlayer)
Vue.config.productionTip = false
Vue.prototype.$md5 = md5
Vue.use(ElementUI)

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
// 定义全局变量
let gmdss = new VueGMDSS()
window.$gmdss = gmdss
// 定义混入变量
Vue.mixin({
  data () {
    return {
      gmdss: window.$gmdss
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js